export class Account {
  name: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  integrationType: string;
  numberOfWeeksToSaveData: number;
}
